module.exports = __webpack_public_path__ + "assets/4d27cddf45eeeac24e1c47fa7b17ac33.png";